/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SenderCompanyVo
 */
export interface SenderCompanyVo {
    /**
     * 公司名称（韩文）
     * @type {string}
     * @memberof SenderCompanyVo
     */
    companyNameKr?: string;
    /**
     * 公司名称（英文）
     * @type {string}
     * @memberof SenderCompanyVo
     */
    companyNameEn?: string;
    /**
     * 清关码
     * @type {string}
     * @memberof SenderCompanyVo
     */
    ctmsNo?: string;
    /**
     * 手机号
     * @type {string}
     * @memberof SenderCompanyVo
     */
    mobileNo?: string;
    /**
     * 营业执照地址
     * @type {string}
     * @memberof SenderCompanyVo
     */
    businessLicenseAddress?: string;
}

/**
 * Check if a given object implements the SenderCompanyVo interface.
 */
export function instanceOfSenderCompanyVo(value: object): value is SenderCompanyVo {
    return true;
}

export function SenderCompanyVoFromJSON(json: any): SenderCompanyVo {
    return SenderCompanyVoFromJSONTyped(json, false);
}

export function SenderCompanyVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderCompanyVo {
    if (json == null) {
        return json;
    }
    return {
        
        'companyNameKr': json['companyNameKr'] == null ? undefined : json['companyNameKr'],
        'companyNameEn': json['companyNameEn'] == null ? undefined : json['companyNameEn'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'businessLicenseAddress': json['businessLicenseAddress'] == null ? undefined : json['businessLicenseAddress'],
    };
}

export function SenderCompanyVoToJSON(json: any): SenderCompanyVo {
    return SenderCompanyVoToJSONTyped(json, false);
}

export function SenderCompanyVoToJSONTyped(value?: SenderCompanyVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyNameKr': value['companyNameKr'],
        'companyNameEn': value['companyNameEn'],
        'ctmsNo': value['ctmsNo'],
        'mobileNo': value['mobileNo'],
        'businessLicenseAddress': value['businessLicenseAddress'],
    };
}

